import { getAssDetailsSteps } from "./assDetails"
import { getAssortmentSteps } from "./assortment"
import { getChangesSteps } from "./changes"
import { getShareSteps } from "./share"
import { getPricingChangesSteps } from "./pricingChanges"
import { getMarketAnalyzerSteps } from "./marketAnalyzer"
import { getPriceDiscountSteps } from "./priceDiscount"
import { getPriceEvolutionSteps } from "./priceEvolution"
import { getSideComparisonSteps } from "./sideComparison"
import { getProductPageKpiSteps } from "./productPageKpi"
import { getProductPageDetailsSteps } from "./productPageDetails"
import { getProductPageImageDetailsSteps } from "./productPageImageDetails"
import { getSosKpiSteps } from "./sosKpi"
import { getSosDetailsSteps } from "./sosDetails"
import { getSosStatusSteps } from "./sosStatus"
import { getMarketplacesGeneralSteps } from "./marketplacesGeneral"
import { getLbbOverviewSteps } from "./lbbOverview"
import { getLbbDetailsSteps } from "./lbbDetails"
import { getSellerDetailsSteps } from "./sellerDetails"
import { getSellerDeepDiveSteps } from "./sellerDeepDive"
import { getDigitalShelfGeneralSteps } from "./digitalShelfGeneral"
import { getShareOfBrowseSteps } from "./shareOfBrowse"
import { getSectionDetailsSteps } from "./sectionDetails"
import { getOffersDetailsSteps } from "./offersDetails"
import { getAmazonReleaseDateSteps } from "./amazonReleaseDate"
import { getEmbargoSteps } from "./embargo"
import { getDynamicAssortmentSteps } from "./dynamicAssortment"
import { getAmazonPPKpisSteps } from "./amazonPPKpis"
import { getFlashOffersSteps } from "./flashOffers"
import { getCatalogueGeneralSteps } from "./catalogueGeneral"
import { getCatalogueDetailsSteps } from "./catalogueDetails"
import { getMonitoringResultsSteps } from "./monitoringResults"

export {
    getAssDetailsSteps, getAssortmentSteps, getChangesSteps, getShareSteps,
    getPricingChangesSteps, getMarketAnalyzerSteps, getPriceDiscountSteps,
    getPriceEvolutionSteps, getSideComparisonSteps,
    getProductPageKpiSteps, getProductPageDetailsSteps, getProductPageImageDetailsSteps,
    getSosKpiSteps, getSosDetailsSteps, getSosStatusSteps,
    getMarketplacesGeneralSteps, getLbbOverviewSteps, getLbbDetailsSteps,
    getSellerDetailsSteps, getSellerDeepDiveSteps,
    getDigitalShelfGeneralSteps, getShareOfBrowseSteps, getSectionDetailsSteps,
    getOffersDetailsSteps,
    getAmazonReleaseDateSteps, getEmbargoSteps, getDynamicAssortmentSteps,
    getAmazonPPKpisSteps, getFlashOffersSteps,
    getCatalogueGeneralSteps, getCatalogueDetailsSteps, getMonitoringResultsSteps,
}

export const TOUR_STEP_FACTORIES = {
    assDetails: getAssDetailsSteps,
    assortment: getAssortmentSteps,
    changes: getChangesSteps,
    share: getShareSteps,
    pricingChanges: getPricingChangesSteps,
    marketAnalyzer: getMarketAnalyzerSteps,
    priceDiscount: getPriceDiscountSteps,
    priceEvolution: getPriceEvolutionSteps,
    sideComparison: getSideComparisonSteps,
    productPageKpi: getProductPageKpiSteps,
    productPageDetails: getProductPageDetailsSteps,
    productPageImageDetails: getProductPageImageDetailsSteps,
    sosKpi: getSosKpiSteps,
    sosDetails: getSosDetailsSteps,
    sosStatus: getSosStatusSteps,
    marketplacesGeneral: getMarketplacesGeneralSteps,
    lbbOverview: getLbbOverviewSteps,
    lbbDetails: getLbbDetailsSteps,
    sellerDetails: getSellerDetailsSteps,
    sellerDeepDive: getSellerDeepDiveSteps,
    digitalShelfGeneral: getDigitalShelfGeneralSteps,
    shareOfBrowse: getShareOfBrowseSteps,
    sectionDetails: getSectionDetailsSteps,
    offersDetails: getOffersDetailsSteps,
    amazonReleaseDate: getAmazonReleaseDateSteps,
    embargo: getEmbargoSteps,
    dynamicAssortment: getDynamicAssortmentSteps,
    amazonPPKpis: getAmazonPPKpisSteps,
    flashOffers: getFlashOffersSteps,
    catalogueGeneral: getCatalogueGeneralSteps,
    catalogueDetails: getCatalogueDetailsSteps,
    monitoringResults: getMonitoringResultsSteps,
}
